<template>
  <div class="min-h-screen">
    <AppNavbar title="Bookings" :back="true" />

    <main class="max-w-7xl mx-auto px-8 py-8">

      <!-- Page header -->
      <div class="mb-8">
        <div class="flex items-center gap-2 text-sm text-slate-400 mb-3">
          <span>Dashboard</span>
          <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
          <span class="text-slate-600 font-medium">Bookings</span>
        </div>
        <div class="flex items-start justify-between gap-6">
          <div>
            <h1 class="text-3xl font-bold text-slate-800">Bookings</h1>
            <p class="text-slate-500 mt-1.5 text-base">Create a new ride or review your existing bookings.</p>
          </div>
          <router-link
            to="/payments"
            class="flex-shrink-0 flex items-center gap-2 bg-white border border-slate-200 text-slate-600 hover:text-emerald-600 hover:border-emerald-200 hover:bg-emerald-50 px-4 py-2 rounded-xl text-sm font-medium transition-colors shadow-sm"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
            </svg>
            Go to Payments
          </router-link>
        </div>
        <div class="mt-4 space-y-2">
          <AlertBanner :message="message" type="success" />
          <AlertBanner :message="error" type="error" />
        </div>
      </div>

      <!-- Two-column grid -->
      <div class="grid grid-cols-1 lg:grid-cols-5 gap-6 items-start">
        <!-- Form: narrower column -->
        <div class="lg:col-span-2">
          <BookingForm @booking-created="loadBookings" />
        </div>
        <!-- List: wider column -->
        <div class="lg:col-span-3">
          <BookingList
            :bookings="bookings"
            :loading="loading"
            @refresh="loadBookings"
          />
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import AppNavbar from "@/components/AppNavbar.vue";
import BookingForm from "@/components/BookingForm.vue";
import BookingList from "@/components/BookingList.vue";
import AlertBanner from "@/components/AlertBanner.vue";

export default {
  name: "BookingsView",
  components: { AppNavbar, BookingForm, BookingList, AlertBanner },
  data() {
    return {
      bookings: [],
      message: "",
      error: "",
      loading: false,
    }
  },
  mounted() {
    if (!this.$store.getters.isAuthenticated) {
      this.$router.push("/login");
      return;
    }
    this.loadBookings();
  },
  methods: {
    async loadBookings() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("fetchBookings");
        this.bookings = response.data.bookings;
      } catch (error) {
        this.error = error.response?.data?.message || "Could not load bookings";
      } finally {
        this.loading = false;
      }
    },

  },
};
</script>
